import * as Icons from "lucide-react";
import type { HelpCategory } from "@/types/HelpArticle";

interface HelpCategoryCardProps {
  category: HelpCategory;
  onClick: () => void;
}

// Predefined gradient classes for Tailwind JIT to detect
// Keys should match the gradient values stored in the database
const gradientClasses: Record<string, string> = {
  "amber-yellow": "bg-gradient-to-br from-amber-200 to-yellow-400",
  "blue-cyan": "bg-gradient-to-br from-blue-200 to-cyan-400",
  "green-emerald": "bg-gradient-to-br from-green-200 to-emerald-400",
  "pink-rose": "bg-gradient-to-br from-pink-200 to-rose-400",
  "purple-violet": "bg-gradient-to-br from-purple-200 to-violet-400",
  "orange-red": "bg-gradient-to-br from-orange-200 to-red-400",
  "teal-cyan": "bg-gradient-to-br from-teal-200 to-cyan-400",
  "indigo-purple": "bg-gradient-to-br from-indigo-200 to-purple-400",
  "slate-gray": "bg-gradient-to-br from-slate-200 to-gray-400",
};

const DEFAULT_GRADIENT = "bg-gradient-to-br from-purple-100 to-violet-200";

const HelpCategoryCard = ({ category, onClick }: HelpCategoryCardProps) => {
  // Get the icon component from lucide-react by name
  const IconComponent = (Icons as any)[category.icon] || Icons.HelpCircle;

  // Map colSpan to actual Tailwind classes (can't use template literals with Tailwind JIT)
  const colSpanClasses: Record<number, string> = {
    1: "lg:col-span-1",
    2: "lg:col-span-2",
    3: "lg:col-span-3",
  };

  const colSpanClass = category.colSpan ? colSpanClasses[category.colSpan] || "" : "";
  const gradientClass = gradientClasses[category.gradient] || DEFAULT_GRADIENT;

  return (
    <div
      className={`${gradientClass} p-6 rounded-md hover:shadow-md transition-shadow cursor-pointer ${colSpanClass}`}
      onClick={onClick}
    >
      <h3 className="font-semibold mb-2 text-2xl flex items-center">
        <IconComponent className="h-8 w-8 mr-2" /> {category.name}
      </h3>
      <p className="text-sm">{category.description}</p>
    </div>
  );
};

export default HelpCategoryCard;
